export function hasTouchableProperty(props) {
  return !!(props.onPress || props.onPressIn || props.onPressOut || props.onLongPress);
}
//# sourceMappingURL=hasProperty.js.map